import { SegmentedButton } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Experience = styled.div`
  border-radius: var(--size-border-radius-xl);
  display: flex;
  padding-top: 16px;
  width: 100%;

  .experience-tabs {
    flex: 1 1 0%;
    word-break: break-word;

    ${({ tabContentPadding }) => `padding-bottom: ${tabContentPadding}px;`}

    & > ${SegmentedButton?.S?.SegmentedButtonTab} {
      background-color: var(--color-neutral-25);
      position: sticky;
      top: -17px;
      z-index: 4;
    }

    ${SegmentedButton?.S?.SegmentedButtonContent} {
      margin-top: 32px;
      z-index: 5;
    }
  }
`;

export { Experience };
